<template>
  <div class="profile-picture-frame-manager">
    <div class="wrap">
      <label for="roles">Select a role:</label>
      <select id="roles" v-model="selectedRole">
        <option
          :value="role.rol_id"
          v-for="role in userRoles"
          :key="role.rol_id"
        >
          {{ role.rol_name }}
        </option>
      </select>
      <div class="img-preview-wrap">
        <img
          :src="circlePreview"
          alt=""
        />
        <img
          :src="squarePreview"
          alt=""
        />
      </div>
    </div>
    <div class="wrap">
      <div class="select-type-wrap">
        <label for="type">Select The Frame Shape:</label>
        <select v-model="type" id="type">
          <option value="circle">Circle</option>
          <option value="square">Square</option>
        </select>
      </div>
      <label for="image"> Select the image for the chosen role:</label>
      <input @change="getFile($event)" type="file" id="image" />
    </div>
    <img class="preview" :src="imgPreview" alt="" />
    <p>*Frame image should not have blank spaces around*</p>
    <button @click="submit">Submit</button>
  </div>
</template>

<script>
import api from "@/api";
export default {
  data() {
    return {
      userRoles: [],
      selectedRole: null,
      formData: new FormData(),
      image: null,
      type: null,
      imageBaseUrl: process.env.VUE_APP_VIDEO_BASE,
      circlePreview: "",
      squarePreview: "",
      ust_id: null
    };
  },
  computed: {
    imgPreview() {
      if (this.image) {
        return URL.createObjectURL(this.image);
      } else return "";
    },
    sid() {
      return localStorage.getItem("sid");
    },
  },
  watch: {
    selectedRole(val) {
      console.log(val,'ovo');
      this.circlePreview = `${process.env.VUE_APP_API_URL}/users/pictureframe?rol_id=${val}&type=circle&sid=${this.sid}`;
      this.squarePreview = `${process.env.VUE_APP_API_URL}/users/pictureframe?rol_id=${val}&type=square&sid=${this.sid}`;
      // console.log(this.circlePreview);
      this.ust_id = val
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getUserRoles();
    },
    async getUserRoles() {
      try {
        const res = await api.getRoles();
        this.userRoles = res.data.res;
        console.log(this.userRoles,'daj da vidimo');
      } catch (error) {
        console.log(error);
      }
    },
    getFile(e) {
      this.image = e.target.files[0];
    },
    async submit() {
      if (!this.image || !this.selectedRole || !this.type) {
        this.handleError(new Error("Please Choose Image, Role and Shape"));
        return;
      }
      this.formData = new FormData();
      this.formData.append("image", this.image);
      this.formData.append("rol_id", this.selectedRole);
      this.formData.append("type", this.type);
      try {
        const res = await api.postRolePictureFrame(this.formData);
        this.image = "";
        this.selectedRole = null;
        this.type = null;
        this.EventBus.$emit("info", {
          message: "Successfully uploaded!",
        });
        console.log(res);
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped lang='scss'>
.profile-picture-frame-manager {
  padding: 40px;
  .preview {
    width: 300px;
    max-width: unset !important;
    max-height: unset !important;
  }
  .wrap {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    margin: 30px 0;
    .img-preview-wrap {
      margin: 30px 0 0 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 300px;
      img {
        display: inline-block;
        width: 100px;
      }
    }
    select {
      width: 300px;
    }
    .select-type-wrap {
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      margin: 0 0 30px 0;
    }
    #image {
      width: 300px;
      margin: 0;
      display: inline;
    }
  }
}
</style>